module.exports = __webpack_public_path__ + "img/videocall.1dbf28d4.jpg";